module.exports = __webpack_public_path__ + "static/img/appPage_3.60b3ced.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/appPage_3.png
// module id = gzSB
// module chunks = 1